"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _TrialActivationSuccessSurveyModal = _interopRequireDefault(require("./TrialActivationSuccessSurveyModal"));

var _activateTrial = require("ui-addon-upgrades/_core/trial/activateTrial");

var _ActivationErrorModal = _interopRequireDefault(require("./ActivationErrorModal"));

var _ActivationSuccessModal = _interopRequireDefault(require("./ActivationSuccessModal"));

var _sources = require("../data/upgradeData/properties/sources");

var _trials = require("../constants/trials");

var _UpgradeProducts = require("self-service-api/constants/UpgradeProducts");

var _RemoteToolsActivationErrorModal = _interopRequireDefault(require("./RemoteToolsActivationErrorModal"));

var STATUSES = {
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success'
};

var TrialActivationModalContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TrialActivationModalContainer, _Component);

  function TrialActivationModalContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TrialActivationModalContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TrialActivationModalContainer).call(this, props));
    _this.state = {
      trialActivationRequestStatus: STATUSES.LOADING,
      error: null
    };
    return _this;
  }

  (0, _createClass2.default)(TrialActivationModalContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;
      var _this$props = this.props,
          upgradeData = _this$props.upgradeData,
          mon339Treatment = _this$props.mon339Treatment;
      (0, _activateTrial.activateTrial)(upgradeData, mon339Treatment).then(function () {
        if (_this2._isMounted) {
          _this2.setState({
            trialActivationRequestStatus: STATUSES.SUCCESS
          });
        }
      }).catch(function (err) {
        if (_this2._isMounted) {
          _this2.setState({
            trialActivationRequestStatus: STATUSES.ERROR,
            error: err
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          trialActivationRequestStatus = _this$state.trialActivationRequestStatus,
          error = _this$state.error;
      var _this$props2 = this.props,
          upgradeData = _this$props2.upgradeData,
          upgradeProduct = _this$props2.upgradeData.upgradeProduct,
          shouldHideSurvey = _this$props2.shouldHideSurvey,
          onSuccess = _this$props2.onSuccess,
          successModalHeader = _this$props2.successModalHeader,
          successModalSubText = _this$props2.successModalSubText,
          successModalCtaText = _this$props2.successModalCtaText,
          showSuccessModalIllustration = _this$props2.showSuccessModalIllustration;
      var shouldShowSurvey = _trials.SURVEY_UPGRADE_PRODUCTS.includes(upgradeProduct) && !shouldHideSurvey;

      switch (trialActivationRequestStatus) {
        case STATUSES.LOADING:
          return null;

        case STATUSES.ERROR:
          // Temporary for remote tools error message
          if (upgradeProduct === _UpgradeProducts.TEMPORARY_REMOTE_TOOLS && error) {
            return _react.default.createElement(_RemoteToolsActivationErrorModal.default, {
              error: error,
              onSuccess: onSuccess
            });
          }

          return _react.default.createElement(_ActivationErrorModal.default, {
            onSuccess: onSuccess
          });

        case STATUSES.SUCCESS:
          if (shouldShowSurvey) {
            return _react.default.createElement(_TrialActivationSuccessSurveyModal.default, {
              onSuccess: onSuccess,
              upgradeData: upgradeData
            });
          }

          return _react.default.createElement(_ActivationSuccessModal.default, {
            type: _sources.sourceKeys.TRIAL,
            onSuccess: onSuccess,
            header: successModalHeader,
            subText: successModalSubText,
            ctaText: successModalCtaText,
            showIllustration: showSuccessModalIllustration
          });

        default:
          return null;
      }
    }
  }]);
  return TrialActivationModalContainer;
}(_react.Component);

TrialActivationModalContainer.defaultProps = {
  mon339Treatment: 'control'
};
TrialActivationModalContainer.propTypes = {
  upgradeData: _propTypes.default.object,
  onSuccess: _propTypes.default.func,
  shouldHideSurvey: _propTypes.default.bool,
  successModalHeader: _propTypes.default.node,
  successModalSubText: _propTypes.default.node,
  successModalCtaText: _propTypes.default.node,
  showSuccessModalIllustration: _propTypes.default.bool,
  mon339Treatment: _propTypes.default.string
};
var _default = TrialActivationModalContainer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/components/TrialActivationModalContainer.js
// module id = 740
// module chunks = 5 6